import {Inject, Injectable, NgZone} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AD_SETTING_COST_CONFIG} from "../../config/api";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class AdSettingsCostService {
    private config = AD_SETTING_COST_CONFIG;
    public visible = new BehaviorSubject(null);

    constructor(private ngZone: NgZone,
                private http: HttpClient) {

    }

    show() {
        this.visible.next(true);
    }

    hide() {
        this.visible.next(false);
    }

    getData() {
        return this.http.post<any>(this.config.data, {});
    }

    saveData(minPerDay, maxPerDay, min, max) {
        return this.http.post<any>(this.config.save, {minPerDay, maxPerDay, min, max});
    }
}
